export enum CustomerIOEvents {
  PWA_OPENED = 'pwa_le_opened',
}
